import { IBaseDataParser } from '../../../../vendor_core/core/src/server/parsers/IBaseDataParser';
import ICoinData from '../../../model/ICoinData';

export default class TRWCoinDataParser implements IBaseDataParser<ICoinData> {
    public check(data: any): boolean {
        return data;
    }

    public parse(data: any): ICoinData[] {
        if (data.refresh) {
            data = data.refresh;
        }

        const state = this.getState(data.wager?.data.stateAfterMainSpin.meter)

        let result: ICoinData = {
            endState: state,
            isCoinRainPlayed: false
        };


        return [result];
    }

    private getState(stateAfterMainSpin: number = 0): number {
        let result = 0;

        if (stateAfterMainSpin > 0 && stateAfterMainSpin < 3) {
            result = 1;
        } else if (stateAfterMainSpin >= 3 && stateAfterMainSpin < 6) {
            result = 2;
        } else if (stateAfterMainSpin >= 6 && stateAfterMainSpin < 10) {
            result = 3;
        } else if (stateAfterMainSpin >= 10 && stateAfterMainSpin < 14) {
            result = 4;
        } else if (stateAfterMainSpin >= 14 && stateAfterMainSpin < 17) {
            result = 5;
        } else if (stateAfterMainSpin >= 17 && stateAfterMainSpin < 20) {
            result = 6;
        } else if (stateAfterMainSpin >= 20 && stateAfterMainSpin < 24) {
            result = 7;
        } else if (stateAfterMainSpin >= 24 && stateAfterMainSpin < 28) {
            result = 8;
        } else if (stateAfterMainSpin >= 28 && stateAfterMainSpin < 31) {
            result = 9;
        } else if (stateAfterMainSpin >= 31 && stateAfterMainSpin < 35) {
            result = 10;
        } else if (stateAfterMainSpin >= 35 && stateAfterMainSpin < 39) {
            result = 11;
        } else if (stateAfterMainSpin >= 39 && stateAfterMainSpin < 42) {
            result = 12;
        } else if (stateAfterMainSpin >= 42 && stateAfterMainSpin < 46) {
            result = 13;
        } else if (stateAfterMainSpin >= 46 && stateAfterMainSpin < 50) {
            result = 14;
        } else if (stateAfterMainSpin >= 50 && stateAfterMainSpin < 55) {
            result = 15;
        } else if (stateAfterMainSpin >= 55) {
            result = 16;
        };

        return result

    }
}
